import React, { useEffect, useState } from "react";
import { Row, Col, Table, Button, Image, Container } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import vjLogo from "./vjLogo.avif";
import "./Response.css";
import { useSelector } from "react-redux";

// import "../product.css";
// import SecurePageSection from "../../SecurePageSection";

function ProductView() {
  const user = useSelector((state) => state.authentication.user);
  const [product, setproduct] = useState([]);
  const [stotal, setstotal] = useState(0);
  const [gst, setgst] = useState(0);
  const [ctotal, setctotal] = useState(0);

  const responseId = useParams();

  const getResponse = async () => {
    try {
      const res = await axios.get(`/api/product/${responseId.Tag_No}/`);
      // console.log(res.data);

      const ratesRes = await axios.get(`/api/rate/1/`);
      const product = res.data;

      const rates = ratesRes.data;

      // Define rate mappings
      const saleGoldRates = {
        "GOLD - 18CT": rates.sgold18,
        "GOLD - 22CT": rates.sgold22,
      };

      // Extract selected types
      const G1Type = product.Gold_01;
      const G2Type = product.Gold_02;

      // Sale rates
      const G1_S_Rate = Math.ceil(saleGoldRates[G1Type] || 0);
      const G2_S_Rate = Math.ceil(saleGoldRates[G2Type] || 0);
      const CS_S_Rate = Math.ceil(rates.cs || 0);
      const MC_S_Rate = Math.ceil(rates.mc || 0);

      const G1_C_Amount = Math.ceil(
        (product.G1_Weight || 0) * product.G1_C_Rate
      );
      const G2_C_Amount = Math.ceil(
        (product.G2_Weight || 0) * product.G2_C_Rate
      );
      const G1_S_Amount = Math.ceil((product.G1_Weight || 0) * G1_S_Rate);
      const G2_S_Amount = Math.ceil((product.G2_Weight || 0) * G2_S_Rate);

      const D1_C_Amount = Math.ceil(
        (product.D1_Weight || 0) * product.D1_C_Rate
      );
      const D2_C_Amount = Math.ceil(
        (product.D2_Weight || 0) * product.D2_C_Rate
      );
      const D3_C_Amount = Math.ceil(
        (product.D3_Weight || 0) * product.D3_C_Rate
      );
      const D4_C_Amount = Math.ceil(
        (product.D4_Weight || 0) * product.D4_C_Rate
      );
      const CS1_S_Amount = Math.ceil((product.CS1_Weight || 0) * CS_S_Rate);
      const CS2_S_Amount = Math.ceil((product.CS2_Weight || 0) * CS_S_Rate);
      const CS3_S_Amount = Math.ceil((product.CS3_Weight || 0) * CS_S_Rate);
      const CS4_S_Amount = Math.ceil((product.CS4_Weight || 0) * CS_S_Rate);

      const CS1_C_Amount = Math.ceil(
        (product.CS1_Weight || 0) * product.CS1_C_Rate
      );
      const CS2_C_Amount = Math.ceil(
        (product.CS2_Weight || 0) * product.CS2_C_Rate
      );
      const CS3_C_Amount = Math.ceil(
        (product.CS3_Weight || 0) * product.CS3_C_Rate
      );
      const CS4_C_Amount = Math.ceil(
        (product.CS4_Weight || 0) * product.CS4_C_Rate
      );

      const D5_C_Amount = Math.ceil(
        (product.D5_Weight || 0) * product.D5_C_Rate
      );
      const D6_C_Amount = Math.ceil(
        (product.D6_Weight || 0) * product.D6_C_Rate
      );
      const D7_C_Amount = Math.ceil(
        (product.D7_Weight || 0) * product.D7_C_Rate
      );
      const D8_C_Amount = Math.ceil(
        (product.D8_Weight || 0) * product.D8_C_Rate
      );
      const D9_C_Amount = Math.ceil(
        (product.D9_Weight || 0) * product.D9_C_Rate
      );
      const D10_C_Amount = Math.ceil(
        (product.D10_Weight || 0) * product.D10_C_Rate
      );
      const D1_S_Amount = Math.ceil(
        (product.D1_Weight || 0) * product.D1_S_Rate
      );
      const D2_S_Amount = Math.ceil(
        (product.D2_Weight || 0) * product.D2_S_Rate
      );
      const D3_S_Amount = Math.ceil(
        (product.D3_Weight || 0) * product.D3_S_Rate
      );
      const D4_S_Amount = Math.ceil(
        (product.D4_Weight || 0) * product.D4_S_Rate
      );
      const D5_S_Amount = Math.ceil(
        (product.D5_Weight || 0) * product.D5_S_Rate
      );
      const D6_S_Amount = Math.ceil(
        (product.D6_Weight || 0) * product.D6_S_Rate
      );
      const D7_S_Amount = Math.ceil(
        (product.D7_Weight || 0) * product.D7_S_Rate
      );
      const D8_S_Amount = Math.ceil(
        (product.D8_Weight || 0) * product.D8_S_Rate
      );
      const D9_S_Amount = Math.ceil(
        (product.D9_Weight || 0) * product.D9_S_Rate
      );
      const D10_S_Amount = Math.ceil(
        (product.D10_Weight || 0) * product.D10_S_Rate
      );

      // Inject into product object
      product.G1_S_Rate = G1_S_Rate;
      product.G2_S_Rate = G2_S_Rate;
      product.CS1_S_Rate = CS_S_Rate;
      product.CS2_S_Rate = CS_S_Rate;
      product.CS3_S_Rate = CS_S_Rate;
      product.CS4_S_Rate = CS_S_Rate;

      product.G1_C_Amount = Math.ceil(G1_C_Amount);
      product.G2_C_Amount = Math.ceil(G2_C_Amount);
      product.G1_S_Amount = Math.ceil(G1_S_Amount);
      product.G2_S_Amount = Math.ceil(G2_S_Amount);

      product.CS1_C_Amount = Math.ceil(CS1_C_Amount);
      product.CS2_C_Amount = Math.ceil(CS2_C_Amount);
      product.CS3_C_Amount = Math.ceil(CS3_C_Amount);
      product.CS4_C_Amount = Math.ceil(CS4_C_Amount);

      product.CS1_S_Amount = Math.ceil(CS1_S_Amount);
      product.CS2_S_Amount = Math.ceil(CS2_S_Amount);
      product.CS3_S_Amount = Math.ceil(CS3_S_Amount);
      product.CS4_S_Amount = Math.ceil(CS4_S_Amount);

      product.D1_C_Amount = Math.ceil(D1_C_Amount);
      product.D1_C_Amount = Math.ceil(D1_C_Amount);
      product.D2_C_Amount = Math.ceil(D2_C_Amount);
      product.D3_C_Amount = Math.ceil(D3_C_Amount);
      product.D4_C_Amount = Math.ceil(D4_C_Amount);
      product.D5_C_Amount = Math.ceil(D5_C_Amount);
      product.D6_C_Amount = Math.ceil(D6_C_Amount);
      product.D7_C_Amount = Math.ceil(D7_C_Amount);
      product.D8_C_Amount = Math.ceil(D8_C_Amount);
      product.D9_C_Amount = Math.ceil(D9_C_Amount);
      product.D10_C_Amount = Math.ceil(D10_C_Amount);
      product.D1_S_Amount = Math.ceil(D1_S_Amount);
      product.D1_S_Amount = Math.ceil(D1_S_Amount);
      product.D2_S_Amount = Math.ceil(D2_S_Amount);
      product.D3_S_Amount = Math.ceil(D3_S_Amount);
      product.D4_S_Amount = Math.ceil(D4_S_Amount);
      product.D5_S_Amount = Math.ceil(D5_S_Amount);
      product.D6_S_Amount = Math.ceil(D6_S_Amount);
      product.D7_S_Amount = Math.ceil(D7_S_Amount);
      product.D8_S_Amount = Math.ceil(D8_S_Amount);
      product.D9_S_Amount = Math.ceil(D9_S_Amount);
      product.D10_S_Amount = Math.ceil(D10_S_Amount);
      product.S_Making = Math.ceil(
        MC_S_Rate * (product.G1_Weight * 1 + product.G2_Weight * 1)
      );

      setproduct(product);

      // 🔹 Calculate STOTAL (sale total)
      const stotal =
        (Math.ceil(product.D1_S_Amount) * 1 || 0) +
        (Math.ceil(product.D2_S_Amount) * 1 || 0) +
        (Math.ceil(product.D3_S_Amount) * 1 || 0) +
        (Math.ceil(product.D4_S_Amount) * 1 || 0) +
        (Math.ceil(product.D5_S_Amount) * 1 || 0) +
        (Math.ceil(product.D6_S_Amount) * 1 || 0) +
        (Math.ceil(product.D7_S_Amount) * 1 || 0) +
        (Math.ceil(product.D8_S_Amount) * 1 || 0) +
        (Math.ceil(product.D9_S_Amount) * 1 || 0) +
        (Math.ceil(product.D10_S_Amount) * 1 || 0) +
        (Math.ceil(product.CS1_S_Amount) * 1 || 0) +
        (Math.ceil(product.CS2_S_Amount) * 1 || 0) +
        (Math.ceil(product.CS3_S_Amount) * 1 || 0) +
        (Math.ceil(product.CS4_S_Amount) * 1 || 0) +
        (Math.ceil(product.CS5_S_Amount) * 1 || 0) +
        (Math.ceil(G1_S_Amount) || 0) +
        (Math.ceil(G2_S_Amount) || 0) +
        (Math.ceil(product.S_Making) * 1 || 0);
      setstotal(stotal);
      setgst(Math.ceil((stotal * 3) / 100));

      // 🔹 Calculate CTOTAL (cost total)
      const ctotal =
        (Math.ceil(product.D1_C_Amount) * 1 || 0) +
        (Math.ceil(product.D2_C_Amount) * 1 || 0) +
        (Math.ceil(product.D3_C_Amount) * 1 || 0) +
        (Math.ceil(product.D4_C_Amount) * 1 || 0) +
        (Math.ceil(product.D5_C_Amount) * 1 || 0) +
        (Math.ceil(product.D6_C_Amount) * 1 || 0) +
        (Math.ceil(product.D7_C_Amount) * 1 || 0) +
        (Math.ceil(product.D8_C_Amount) * 1 || 0) +
        (Math.ceil(product.D9_C_Amount) * 1 || 0) +
        (Math.ceil(product.D10_C_Amount) * 1 || 0) +
        (Math.ceil(product.CS1_C_Amount) * 1 || 0) +
        (Math.ceil(product.CS2_C_Amount) * 1 || 0) +
        (Math.ceil(product.CS3_C_Amount) * 1 || 0) +
        (Math.ceil(product.CS4_C_Amount) * 1 || 0) +
        (Math.ceil(product.CS5_C_Amount) * 1 || 0) +
        (Math.ceil(product.G1_C_Amount) || 0) +
        (Math.ceil(product.G2_C_Amount) || 0) +
        (Math.ceil(product.C_Making) * 1 || 0);
      setctotal(ctotal);

      // console.log("Rates:", { G1_S_Rate, G2_S_Rate });
      // console.log("Amounts:", {
      //   G1_S_Amount,
      //   G2_S_Amount,
      // });
      // console.log("Totals:", { ctotal, stotal });
    } catch (error) {
      console.error("Error fetching response:", error);
    }
  };

  useEffect(() => {
    getResponse();
    console.log("1");
  }, [responseId.Tag_No]);

  const navigate = useNavigate();

  const editForm = () => {
    navigate(`/product/edit/${product.Tag_No}`);
  };

  const printDocument = () => {
    var divContents = document.getElementById("mainForm").innerHTML;
    var a = window.open("", "blank", "height=1123,width=800,scrollbars=yes,");
    a.document.write("<html>");
    a.document.write("<link>");
    a.document
      .write(`<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous"
    />`);
    a.document.write("</link>");

    a.document.write(`
    <title>Form B</title>
    `);
    a.document.write("<style>");
    a.document.write(`@media print {
      @page {
        margin-top: 20px;
        margin-bottom: 20px;
        margin-left: 20px;
        margin-right: 20px;
      }
    }

    html {
      overflow-y: auto;
    }

    fResponseBody {
      padding: 20px 20px;
      margin: 0px 20px;
      width: 800px;
      height: 1123px;
      background: #fff;
      overflow-y: auto;
    }

    .page{
      page-break-after: always;
    }

    .centerFormat {
      width: 800px;
      margin: 0 auto;
    }

    .section2, .section3{
      margin-top: 30px;
    }

    .section4{
      margin-top: 20px;
    }

    .bordered-col{
      padding: 3px 10px;
      border: 1px solid #000;
    }

    .bordered-mid-col{
      padding: 3px 10px;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
    }

    .bordered-row{
      padding: 3px 0;
      border: 1px solid #000;
    }

    .bordered-mid-row{
      padding: 3px 0px;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
    }

    .bordered-col-b{
      padding: 3px 5px;
      border: 1px solid #000;
    }

    .blueBG {
      background: rgb(185, 213, 250);
      border-radius: 8px;
      height: 20px;
      margin-bottom: 5px;
    }

    .bannerText {
      margin-top: 20px;
    }

    .bannerText h1 {
      font-family: "Arial-Bold";
      font-size: 24px;
      font-weight: 600;
    }

    .bannerText h2 {
      font-family: "Arial-Bold";
      font-size: 20px;
      font-weight: 400;
    }

    .toptext {
      margin: 20px 0;
    }

    .logoImage {
      height: 80px;
      margin: 10px;
    }

    .bannerYellow {
      background: #ffcc29;
      border-top: 12px solid #3e4095;
      margin-bottom: 30px;
      -webkit-print-color-adjust: exact;
    }

    .Tbox {
      border: 1px solid rgb(0, 0, 0);
      padding: 11px 15px;
      margin: 20px 0;
    }

    .Tsingle-enter {
      font-family: "Arial";
      font-size: 12px;
      margin-bottom: 0;
    }

    .Tsingle-enter-label {
      font-family: "Arial";
      font-size: 12px;
      margin-top: 3px;
      margin-bottom: 0;
      line-height: 97%;
    }

    .Tdouble-enter {
      font-family: "Arial";
      margin-top: 11px;
      font-size: 12px;
      margin-bottom: 0;
    }

    .Tsign-enter {
      font-family: "Arial";
      margin-top: 30px;
      font-size: 12px;
      margin-bottom: 0;
    }

    .Hdouble-enter {
      font-family: "Arial";
      margin: 16px auto;
      font-size: 16px;
      color: #000;
      font-weight: 600;
    }

    .H3double-enter {
      font-family: "Arial";
      margin: 0;
      margin-top: 14px;
      font-size: 14px;
      color: #000;
      font-weight: 600;
    }

    .H3single-enter {
      font-family: "Arial";
      margin: 0;
      font-size: 14px;
      color: #000;
      font-weight: 600;
    }

    .H4single-enter {
      font-family: "Arial";
      margin: 0;
      font-size: 12px;
      color: #000;
      font-weight: 600;
    }

    .Lsingle-enter li {
      font-family: "Arial";
      font-size: 12px;
      margin-bottom: 0;
    }

    .Ldouble-enter li {
      font-family: "Arial";
      font-size: 12px;
      margin-bottom: 0;
      margin-top: 12px
    }

    .response {
      font-family: "Arial";
      font-size: 12px;
      font-weight: 600;
      text-decoration: underline;
    }

    .Tsingle {
      font-family: "Arial";
      font-size: 16px;
      text-decoration: none;
      font-weight: 400;
      color: rgb(0, 0, 0);
      margin-bottom: 8px;
    }

    .Tdouble {
      font-family: "Arial";
      font-size: 16px;
      text-decoration: none;
      font-weight: 400;
      color: rgb(0, 0, 0);
      margin-bottom: 24px;
    }`);
    a.document.write("</style>");
    a.document.write("<body>");
    a.document.write(divContents);
    a.document.write("</body></html>");
    a.document.close();
    setTimeout(function () {
      a.print();
    }, 1000);
  };

  return (
    <div>
      <Container style={{ maxWidth: "95%", padding: "2vh 0" }}>
        {user && (
          <>
            <Row style={{ marginBottom: "1em", marginTop: "1em" }}>
              <Col className="d-flex justify-content-center">
                <Button onClick={printDocument} variant="primary">
                  Download
                </Button>
              </Col>
            </Row>
            <Row style={{ marginBottom: "1em", marginTop: "1em" }}>
              <Col className="d-flex justify-content-center">
                <Button onClick={editForm} variant="primary">
                  Edit
                </Button>
              </Col>
            </Row>
          </>
        )}

        <div id="mainForm" className="centerFormat">
          <div className="fResponseBody">
            <Row style={{ marginBottom: "1em", marginTop: "1em" }}>
              <Col className="d-flex justify-content-center">
                <Image
                  src={vjLogo}
                  className="productImage"
                  style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    width: "160px",
                  }}
                  alt={product.Tag_No}
                  fluid
                />{" "}
              </Col>
            </Row>

            <Row>
              <Col md={4} xs={12}>
                <div className="productTopBox">
                  <h3>Product</h3>
                  <p>{product.Ornament + " " + product.Tag_No}</p>
                </div>
              </Col>
              <Col md={4} xs={12}>
                <div className="productTopBox">
                  <h3>Certificate Number</h3>
                  <p>{product.Certificate_No}</p>
                </div>
              </Col>
              <Col md={4} xs={12}>
                <Row>
                  <Col>
                    <div className="productTopBox">
                      <h3>Colour </h3>
                      <p>E - F </p>
                    </div>
                  </Col>
                  <Col>
                    <div className="productTopBox">
                      <h3>Clarity</h3>
                      <p>IF - VVS1</p>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              {user && (
                <Image
                  src={product.image}
                  className="productImage mx-auto d-block"
                  alt={product.Tag_No}
                  style={{
                    maxWidth: "240px",
                    maxHeight: "240px",
                    height: "auto",
                    width: "auto",
                    margin: "15px 0",
                  }}
                  fluid
                />
              )}
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <Table responsive="md" striped bordered>
                <thead className="tableHead">
                  <tr>
                    <th className="tHeadText">Elements</th>
                    <th className="tHeadText">Pcs</th>
                    <th className="tHeadText">Weight</th>
                    {user && <th className="tHeadText">Cost Rate</th>}
                    {user && <th className="tHeadText">Cost Amount</th>}
                    <th className="tHeadText">Rate</th>
                    <th className="tHeadText">Amount</th>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {(() => {
                    if (product.Diamond_01 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D1_Pcs}</td>
                          <td className="tCellText">{product.D1_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D1_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.D1_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.D1_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D1_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Diamond_02 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D2_Pcs}</td>
                          <td className="tCellText">{product.D2_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D2_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.D2_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.D2_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D2_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Diamond_03 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D3_Pcs}</td>
                          <td className="tCellText">{product.D3_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D3_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.D3_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.D3_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D3_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Diamond_04 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D4_Pcs}</td>
                          <td className="tCellText">{product.D4_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D4_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.D4_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.D4_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D4_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Diamond_05 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D5_Pcs}</td>
                          <td className="tCellText">{product.D5_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D5_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.D5_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.D5_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D5_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Diamond_06 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D6_Pcs}</td>
                          <td className="tCellText">{product.D6_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D6_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.D6_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.D6_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D6_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Diamond_07 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D7_Pcs}</td>
                          <td className="tCellText">{product.D7_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D7_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.D7_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.D7_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D7_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Diamond_08 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D8_Pcs}</td>
                          <td className="tCellText">{product.D8_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D8_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.D8_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.D8_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D8_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Diamond_09 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D9_Pcs}</td>
                          <td className="tCellText">{product.D9_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D9_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.D9_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.D9_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D9_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Diamond_010 !== null) {
                      return (
                        <tr>
                          {user && <td className="tCellText">DIAMONDS</td>}
                          {!user && <td className="tCellText">DIAMONDS</td>}
                          <td className="tCellText">{product.D10_Pcs}</td>
                          <td className="tCellText">{product.D10_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.D10_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">
                              {product.D10_C_Amount}
                            </td>
                          )}
                          <td className="tCellText">{product.D10_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.D10_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}

                  {(() => {
                    if (product.CStone_01 !== null) {
                      return (
                        <tr>
                          <td className="tCellText">C.STONES</td>
                          <td className="tCellText">{product.CS1_Pcs}</td>
                          <td className="tCellText">{product.CS1_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.CS1_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">
                              {product.CS1_C_Amount}
                            </td>
                          )}
                          <td className="tCellText">{product.CS1_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.CS1_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.CStone_02 !== null) {
                      return (
                        <tr>
                          <td className="tCellText">C.STONES</td>
                          <td className="tCellText">{product.CS2_Pcs}</td>
                          <td className="tCellText">{product.CS2_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.CS2_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">
                              {product.CS2_C_Amount}
                            </td>
                          )}
                          <td className="tCellText">{product.CS2_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.CS2_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.CStone_03 !== null) {
                      return (
                        <tr>
                          <td className="tCellText">C.STONES</td>
                          <td className="tCellText">{product.CS3_Pcs}</td>
                          <td className="tCellText">{product.CS3_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.CS3_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">
                              {product.CS3_C_Amount}
                            </td>
                          )}
                          <td className="tCellText">{product.CS3_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.CS3_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.CStone_04 !== null) {
                      return (
                        <tr>
                          <td className="tCellText">C.STONES</td>
                          <td className="tCellText">{product.CS4_Pcs}</td>
                          <td className="tCellText">{product.CS4_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.CS4_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">
                              {product.CS4_C_Amount}
                            </td>
                          )}
                          <td className="tCellText">{product.CS4_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.CS4_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.CStone_05 !== null) {
                      return (
                        <tr>
                          <td className="tCellText">C.STONES</td>
                          <td className="tCellText">{product.CS5_Pcs}</td>
                          <td className="tCellText">{product.CS5_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.CS5_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">
                              {product.CS5_C_Amount}
                            </td>
                          )}
                          <td className="tCellText">{product.CS5_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.CS5_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}

                  {(() => {
                    if (product.Gold_01 !== null) {
                      return (
                        <tr>
                          <td className="tCellText">{product.Gold_01}</td>
                          <td className="tCellText">{product.x}</td>
                          <td className="tCellText">{product.G1_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.G1_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.G1_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.G1_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.G1_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (product.Gold_02 !== null) {
                      return (
                        <tr>
                          <td className="tCellText">{product.Gold_02}</td>
                          <td className="tCellText">{product.x}</td>
                          <td className="tCellText">{product.G2_Weight}</td>
                          {user && (
                            <td className="tCellText">{product.G2_C_Rate}</td>
                          )}
                          {user && (
                            <td className="tCellText">{product.G2_C_Amount}</td>
                          )}
                          <td className="tCellText">{product.G2_S_Rate}</td>
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.G2_S_Amount}
                          </td>
                        </tr>
                      );
                    }
                  })()}

                  {(() => {
                    if (product.S_Making !== null) {
                      return (
                        <tr>
                          <td className="tCellText">MKG.CHRGS</td>
                          <td className="tCellText">{product.x}</td>
                          <td className="tCellText">{product.x}</td>
                          {user && <td className="tCellText">{product.x}</td>}
                          {user && (
                            <td className="tCellText">{product.C_Making}</td>
                          )}
                          {!user && <td className="tCellText">{product.x}</td>}
                          {user && <td className="tCellText">{product.x}</td>}
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {product.S_Making}
                          </td>
                        </tr>
                      );
                    }
                  })()}

                  {(() => {
                    if (stotal !== null) {
                      return (
                        <tr>
                          <td className="tCellText">BEF.GST</td>
                          <td className="tCellText">{product.x}</td>
                          <td className="tCellText">{product.x}</td>
                          {user && <td className="tCellText">{product.x}</td>}
                          {user && (
                            <td
                              className="tCellText"
                              style={{ fontWeight: "700" }}
                            >
                              {ctotal}
                            </td>
                          )}
                          {!user && <td className="tCellText">{product.x}</td>}
                          {user && <td className="tCellText">{product.x}</td>}
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {stotal}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (gst !== null) {
                      return (
                        <tr>
                          <td className="tCellText">GST</td>
                          <td className="tCellText">{product.x}</td>
                          <td className="tCellText">{product.x}</td>
                          {user && <td className="tCellText">{product.x}</td>}
                          {user && <td className="tCellText">{product.x}</td>}
                          {!user && <td className="tCellText">{product.x}</td>}
                          {user && <td className="tCellText">{product.x}</td>}
                          <td
                            className="tCellText"
                            style={{ textAlign: "right" }}
                          >
                            {gst}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                  {(() => {
                    if (stotal !== null) {
                      return (
                        <tr>
                          <td className="tCellText">TOTAL</td>
                          <td className="tCellText">{product.x}</td>
                          <td className="tCellText">{product.x}</td>
                          {user && <td className="tCellText">{product.x}</td>}
                          {user && <td className="tCellText">{product.x}</td>}
                          {!user && <td className="tCellText">{product.x}</td>}
                          {user && <td className="tCellText">{product.x}</td>}
                          <td
                            className="tCellText"
                            style={{ fontWeight: "700", textAlign: "right" }}
                          >
                            {stotal + gst}
                          </td>
                        </tr>
                      );
                    }
                  })()}
                </tbody>
              </Table>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default ProductView;
